import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { BrandTile } from "./Brand";

export default function VoucherCard({ r, compact = false }) {
    const minPts = Math.round(r.min_value * (r.points_per_inr || 4));
    return (
        <Link
            to={`/voucher/${r.id}`}
            data-testid={`voucher-card-${r.brand_name}`}
            className="group fx-card fx-card-hover relative overflow-hidden flex flex-col"
        >
            <div className={`${compact ? "aspect-[5/3]" : "aspect-[4/3]"} relative overflow-hidden bg-white`}>
                <BrandTile url={r.brand_logo_url} fallback={r.fallback_logo_url} name={r.brand_name} />
                {r.discount_percent > 0 && (
                    <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-[#e11d48] text-white text-[10px] font-bold uppercase tracking-wide shadow-md">
                        {r.discount_percent}% OFF
                    </span>
                )}
                {r.featured && (
                    <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-[#c9a959]/95 text-[#0b1437] text-[10px] font-bold uppercase tracking-wide">
                        Trending
                    </span>
                )}
            </div>
            <div className="p-3 bg-white">
                <p className={`font-semibold truncate text-[#0b1437] ${compact ? "text-xs" : "text-sm"}`}>{r.brand_name}</p>
                <p className="text-[11px] text-[#6b7280] truncate">{r.category}</p>
                <div className="flex items-center justify-between mt-2">
                    <p className={`${compact ? "text-xs" : "text-sm"} font-bold text-[#0b1437]`}>
                        Starting <span className="text-[#c9a959]">₹{r.min_value}</span>
                    </p>
                    <span className="inline-flex items-center gap-0.5 text-[10px] text-[#6b7280]">
                        <Star size={10} className="fill-[#c9a959] text-[#c9a959]" /> 4.{3 + ((r.brand_name?.length || 0) % 6)}
                    </span>
                </div>
                <p className="text-[10px] text-[#9ca3af] mt-1">{minPts.toLocaleString("en-IN")} pts equivalent</p>
            </div>
        </Link>
    );
}
